import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter, Instagram, Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-50 dark:bg-gray-900 pt-20 pb-10">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Information */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center">
              <span className="text-2xl font-bold text-primary">fictional.stream</span>
            </Link>
            <p className="text-muted-foreground mt-4 max-w-xs">
              Transforming businesses with AI-powered solutions. Your global partner for intelligent innovation.
            </p>
            <div className="flex space-x-4 mt-6">
              <a 
                href="https://x.com/fictionalstream" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover-lift text-gray-500 hover:text-primary" 
                aria-label="Twitter"
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a 
                href="https://www.linkedin.com/company/fictional-stream" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover-lift text-gray-500 hover:text-primary" 
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
              {/* Instagram link - to be added later
              <a 
                href="#" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover-lift text-gray-500 hover:text-primary" 
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              */}
              {/* Facebook link - to be added later
              <a 
                href="#" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover-lift text-gray-500 hover:text-primary" 
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              */}
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-4">
              Services
            </h3>
            <ul className="space-y-3">
              {[
                { name: 'Data Analytics', path: '/services/data-analytics' },
                { name: 'Machine Learning', path: '/services/machine-learning' },
                { name: 'AI Models', path: '/services/ai-models' },
                { name: 'Computer Vision', path: '/services/computer-vision' },
                { name: 'Robotics Automation', path: '/services/robotics-automation' }
              ].map((service) => (
                <li key={service.name}>
                  <Link 
                    to={service.path} 
                    className="text-muted-foreground hover:text-primary transition-colors hover-lift inline-block"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-4">
              Company
            </h3>
            <ul className="space-y-3">
              {[
                { name: 'About Us', path: '/about' },
                { name: 'Careers', path: '/careers' },
                { name: 'Blog', path: '/blog' },
                // { name: 'Case Studies', path: '/case-studies' },
                { name: 'Contact', path: '/contact' },
              ].map((item) => (
                <li key={item.name}>
                  <Link 
                    to={item.path} 
                    className="text-muted-foreground hover:text-primary transition-colors hover-lift inline-block"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-4">
              Contact Us
            </h3>
            <ul className="space-y-3 text-muted-foreground">
              <li className="flex items-start">
                <MapPin className="h-5 w-5 mr-3 text-primary flex-shrink-0 mt-0.5" />
                <span>7/9a Dhanam Nagar, No: 04 Veerapandi, Coimbatore-641019</span>
              </li>
              <li className="flex items-center">
                <Phone className="h-5 w-5 text-primary mr-3 flex-shrink-0" />
                <span>+91 9360214003</span>
              </li>
              <li className="flex items-center">
                <Mail className="h-5 w-5 mr-3 text-primary flex-shrink-0" />
                <span>support@fictionalstream.zohodesk.in <span className="text-xs text-muted-foreground">(For new and existing customers)</span></span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-800">
          <p className="text-sm text-muted-foreground text-center">
            © {new Date().getFullYear()} fictional.stream. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
